let menuItem = [
  {
    url: '/org-owner/home',
    name: 'Insights',
    icon: 'HomeIcon',
    slug: 'home',
    i18n: 'Home',
  },
  {
    url: '/org-owner/nurse-dashboard',
    name: 'nurse-dashboard',
    icon: 'HomeIcon',
    slug: 'home',
    i18n: 'Home',
  },
  ...['NZ', 'AU'].includes(process.env.VUE_APP_REGION) ? [
    {
      url: '/org-owner/notice-board',
      name: 'Dashboard',
      icon: 'MonitorIcon',
      slug: 'dashboard',
      i18n: 'Notice Board',
    },
    {
      url: '/org-owner/shop',
      name: 'Shop',
      icon: 'ShoppingBagIcon',
      slug: 'shop',
      i18n: 'Products',
    },
    {
      url: '/org-owner/dispense-request',
      name: 'Dispense Request',
      icon: 'ListIcon',
      slug: 'dispense-request',
      i18n: 'Dispense Request',
    },
    {
      url: '/org-owner/orders',
      name: 'My Orders',
      slug: 'orders',
      i18n: 'My Orders',
      icon: 'TruckIcon',
    },
    {
      url: '/org-owner/patients',
      name: 'Patients',
      slug: 'pages-register-nurse',
      i18n: 'Patients',
      icon: 'FolderPlusIcon',
    },
    {
      url: '/org-owner/invoices',
      name: 'Invoice Management',
      slug: 'invoice',
      i18n: 'Invoices',
      icon: 'DollarSignIcon',
    },
    {
      url: '/org-owner/pos',
      name: 'POS',
      slug: 'pos',
      i18n: 'POS',
      icon: 'DollarSignIcon',
    },
    {
      url: '/org-owner/events',
      name: 'Training & Events',
      icon: 'CalendarIcon',
      slug: 'events',
      i18n: 'Training & Events',
    },
    {
      url: '/org-owner/referral',
      name: 'Refer Someone to Fresh',
      slug: 'referral',
      i18n: 'Refer Someone to Fresh',
      icon: 'UserPlusIcon',
    },
    {
      header: 'Resource Hub',
      i18n: 'Resource Hub',
      items: [
        {
          url: '/org-owner/resources',
          name: 'Resources',
          icon: 'CodepenIcon',
          slug: 'resources',
          i18n: 'Resources',
        },
      ],
    },
    {
      header: 'Compliance',
      i18n: 'Compliance',
      items: [
        {
          url: '/org-owner/drugbook',
          name: 'Drugbook',
          icon: 'BookIcon',
          slug: 'drugbook',
          i18n: 'Drugbook',
        },
        {
          url: '/org-owner/inventory',
          name: 'Inventory',
          featherIcon: false,
          icon: 'kitchen',
          slug: 'inventory',
          i18n: 'Inventory',
        },
        {
          url: '/org-owner/compliance',
          name: 'Compliance',
          icon: 'GridIcon',
          slug: 'compliance',
          i18n: 'Compliance Checks',
        },
      ],
    },
  ] : [
    {
      url: '/org-owner/patients',
      name: 'Patients',
      slug: 'pages-register-nurse',
      i18n: 'Patients',
      icon: 'FolderPlusIcon',
    },
    {
      url: '/org-owner/pos',
      name: 'POS',
      slug: 'pos',
      i18n: 'POS',
      icon: 'DollarSignIcon',
    },
    {
      url: '/org-owner/invoices',
      name: 'Invoice Management',
      slug: 'invoice',
      i18n: 'Invoices',
      icon: 'DollarSignIcon',
    },
    {
      url: '/org-owner/events',
      name: 'Training & Events',
      icon: 'CalendarIcon',
      slug: 'events',
      i18n: 'Training & Events',
    },
    {
      url: '/org-owner/referral',
      name: 'Refer Someone to Fresh',
      slug: 'referral',
      i18n: 'Refer Someone to Fresh',
      icon: 'UserPlusIcon',
    },
    {
      url: '/org-owner/resources',
      name: 'Resources',
      icon: 'CodepenIcon',
      slug: 'resources',
      i18n: 'Resources',
    },
    {
      url: '/org-owner/compliance',
      name: 'Compliance',
      icon: 'GridIcon',
      slug: 'compliance',
      i18n: 'Compliance Checks',
    },
    {
      url: '/org-owner/drugbook',
      name: 'Drugbook',
      icon: 'BookIcon',
      slug: 'drugbook',
      i18n: 'Drugbook',
    },
    {
      url: '/org-owner/inventory',
      name: 'Inventory',
      featherIcon: false,
      icon: 'kitchen',
      slug: 'inventory',
      i18n: 'Inventory',
    },
    {
      url: '/org-owner/consent-forms',
      name: 'Consent Forms',
      icon: 'ActivityIcon',
      slug: 'consent-forms',
      i18n: 'Consent Forms',
    },
    {
      url: '/org-owner/shop',
      name: 'Shop',
      icon: 'ShoppingBagIcon',
      slug: 'shop',
      i18n: 'Shop',
    },
    {
      url: '/org-owner/orders',
      name: 'My Orders',
      slug: 'orders',
      i18n: 'My Orders',
      icon: 'TruckIcon',
    },
  ],
  {
    header: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'Settings',
    items: [
      {
        url: '/org-owner/clinics',
        name: 'org-ownerClinics',
        slug: 'org-owner-clinics-management',
        i18n: 'Clinics',
        icon: 'HomeIcon',
      },
      {
        url: '/org-owner/staff',
        name: 'Staff',
        icon: 'UsersIcon',
        slug: 'staff',
        i18n: 'Staff',
      },
      ...['NZ', 'AU'].includes(process.env.VUE_APP_REGION) ? [
        {
          url: '/org-owner/consent-forms',
          name: 'Consent Forms',
          icon: 'ActivityIcon',
          slug: 'consent-forms',
          i18n: 'Consent Forms',
          permission: 'CustomConsentForm',
        },
        {
          url: '/org-owner/aftercare',
          name: 'Aftercare Docs',
          slug: 'aftercare-docs',
          icon: 'FileTextIcon',
          i18n: 'Aftercare Docs',
          permission: 'CustomAftercareDocument',
        },
      ] : [],
      {
        url: '/org-owner/settings/products-list',
        name: 'OrgOwner Products List',
        slug: 'org-owner-products-list',
        icon: 'CheckSquareIcon',
        i18n: 'Products List',
      },
      {
        url: '/org-owner/settings/custom-products-list',
        name: 'OrgOwner Custom Products List',
        slug: 'org-owner-custom-products-list',
        icon: 'CheckSquareIcon',
        i18n: 'Products List',
      },
      {
        url: '/org-owner/settings/treatment-areas',
        name: 'org-owner Treatment Areas',
        slug: 'org-owner-treatment-areas',
        icon: 'ShuffleIcon',
        i18n: 'Treatment Areas',
      },
    ],
  },
];

/** 
 * PRODUCTION FLAG
 * This will be removed later from POS updates 
 * */

export default menuItem;
